var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"StepField"},[_c('Btn',{staticClass:"inv",attrs:{"icon":"edit"},on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.isOpen)?_c('div',{staticClass:"StepField-form"},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }